<template>
  <v-container fill-height>
    <v-row>
      <v-col v-for="(item, i) in articleList" :key="i" cols="12">
        <v-card :color="item.color" dark flat>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="text-sm" v-text="item.title"></v-card-title>
              <v-card-subtitle v-text="item.authName"></v-card-subtitle>
            </div>
          </div>

          <v-list-item>
            <v-list-item-content>
              <v-btn text x-large @click="goTo(item.link, item.author)">
                <p class="text-center font-weight-bold headline">Read More</p>
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <br />
        <br />
        <br />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props:[
    "articleList"
  ],
  methods: {
    goTo: function(page, author) {
      this.$router.push({ name: page, params: { author: author } });
    }
  }
};
</script>